
<div class="panel-view" :class="{ 'panel-open': $slots.panel }">
  <section class="page">
    <slot />
  </section>

  <section
    v-if="$slots.panel"
    id="side-panel"
    class="panel"
  >
    <slot name="panel" />
  </section>
</div>
